require(['jquery'], function($) {

	$('.load-more-events').on('click', function(e) {
		e.preventDefault();

		var button = $(this);

		button.attr('disabled', 'disabled');

		var date_now = button.attr("data-date");
		var offset = button.attr("data-offset");
		var count = button.attr("data-count");
		console.log(date_now);
		console.log(offset);
		console.log(count);

		$.ajax({
			type: 'POST',
			data: {
				action: 'get_past_events',
				date: date_now,
				offset: offset,
				count: count,
			},
		}).done(function(data) {
			button.attr("data-offset", parseInt(offset) + parseInt(count));
			console.log(data);

			for(var i = 0; i < data.length; i++) {
				appendEvent(data[i]);
			}


			if(data.length < parseInt(count)) {
				button.slideUp('slow');
			}


		}).fail(function(error) {
			console.log('Request failed!');
			console.log(error);
		}).always(function() {
			button.removeAttr('disabled');
		});
	});


	function appendEvent(event) {
		var eventTemplate = '<div class="event" style="display: none;">' +
								'<div class="date">' + 
									'<span class="day">' + event['day'] + '</span>' +
									'<p>' +
										'<span>'+ event['month'] +'</span>' +
										'<span>'+ event['year'] +'</span>' +
									'</p>' +
								'</div>' +
								'<div class="content">' +
									'<p class="title">'+ event['title'] +'</p>' +
									'<p>'+ event['description'] +'</p>' +
									 event['link'] +
								'</div>' +
							'</div>';

		console.log(eventTemplate);

		$(eventTemplate).appendTo('.events-list-past').show('slow');
	}

});
define("root/Assets/Templates/Html/PastEvents/Js/PastEvents", function(){});

